// tslint:disable
/**
 * Speedtest Plus API
 * This is the API for Speedtest Plus
 *
 * The version of the OpenAPI document: 0.28.0
 * Contact: speedtest-api@anw.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ModemFinalKind {
    ModemFinalAvailable = 'ModemFinalAvailable',
    ModemFinalDidNotRun = 'ModemFinalDidNotRun',
    ModemFinalFailed = 'ModemFinalFailed'
}

